module.exports = __webpack_public_path__ + "static/media/header.ffecce74.png";